const info = {
  ZH: { //中文翻译
    DataName: "\u6750\u6599\u6570\u636E\u8868\u540D\u79F0\uFF1A",
    'id&ver': "MDS ID/\u7248\u672C\u53F7\uFF1A",
    table: "\u8868\u5355\u57FA\u672C\u4FE1\u606F",
    basicInfo: "\u53D1\u9001\u65B9\u57FA\u672C\u4FE1\u606F",
    sendername: "\u53D1\u9001\u4EBA\uFF1A",
    senderTelephone: "\u8054\u7CFB\u7535\u8BDD\uFF1A",
    companyName: "\u4F01\u4E1A\u540D\u79F0\uFF08ID\uFF09\uFF1A",
    address: "\u5730\u5740\uFF1A",
    sendDate: "\u53D1\u9001\u65E5\u671F\uFF1A",
    rbasicInfo: "\u6279\u51C6\u65B9\u57FA\u672C\u4FE1\u606F",
    rreceiveName: "\u6279\u51C6\u4EBA\uFF1A",
    rreceiveTelephone: "\u8054\u7CFB\u7535\u8BDD\uFF1A",
    rcompanyName: "\u4F01\u4E1A\u540D\u79F0\uFF08ID\uFF09\uFF1A",
    rpizhunDate: "\u6279\u51C6\u65E5\u671F\uFF1A",
    analyse: "\u6709\u5BB3\u7269\u8D28\u5206\u6790\u5217\u8868",
    beizhu: "(\u6CE8\uFF1A\u221A\uFF1A\u542B\u6709\u4E14\u5408\u89C4\uFF1B\u2573\uFF1A\u4E0D\u5408\u89C4\uFF1BN.A.\uFF1A\u4E0D\u542B\u6709\uFF1B\u3007\uFF1A\u9AD8\u4E8E\u9650\u503C\uFF0C\u4F46\u8C41\u514D\u3002)",
    partcomponetName: "\u5B50\u90E8\u4EF6\u540D\u79F0",
    materialName: "\u6750\u6599\u540D\u79F0",
    materialClass: "\u6750\u6599\u7C7B\u522B",
    option: "\u8C41\u514D\u9009\u9879",
    isOpen:'是否开放',
    secretOption:"\u4FDD\u5BC6\u6027",
    delete: '\u5220\u9664',
    success1: '\u5DF2\u6279\u51C6\u6216\u5DF2\u4E0B\u8F7D\u7684MDS\u65E0\u6CD5\u5220\u9664\uFF0C\u5176\u4F59\u8868\u5355\u5220\u9664\u6210\u529F\uFF01',
    copyType: '\u9009\u62E9\u62F7\u8D1D\u7C7B\u578B',
    forward: '\u8F6C\u53D1',
    title: '\u590D\u5236MDS',
    newVersion: '\u65B0\u7248\u672C',
    copy: '\u62F7 \u8D1D',
    continue: '\u7EE7 \u7EED',
    notice: ' \u6B64MDS\u4E2D\u5305\u542B\u5DF2\u903B\u8F91\u5220\u9664\u7684MDS,\u590D\u5236\u8FC7\u7A0B\u4F1A\u5C06\u5220\u9664\u7684\u90E8\u5206\u4ECE\u526F\u672C\u4E2D\u79FB\u9664,\u662F\u5426\u7EE7\u7EED?',
    cancel: '\u53D6 \u6D88',
    pleasewait: '\u8BF7\u7A0D\u7B49...',
    imdsSelect: '\u8D85\u8FC710\u6761\u6570\u636E\uFF0C\u5F71\u54CD\u4E0A\u4F20\u4E0B\u8F7D\u6548\u7387\uFF0C\u5EFA\u8BAE10\u6761\u6570\u636E\u4EE5\u5185\uFF01',
    lock: ' \u9501\u5B9A',
    lockmsg: ' \u8868\u5355\u5DF2\u9501\u5B9A\uFF0C\u5176\u4ED6\u7528\u6237\u4E0D\u53EF\u4FEE\u6539\u3001\u5220\u9664\u3001\u6807\u8BB0\u8FC7\u671F',
    unlock: ' \u89E3\u9501',
    unlockmsg: ' \u8868\u5355\u5DF2\u89E3\u9501',
    checkVehcleMsg: '\u8be5\u96f6\u90e8\u4ef6\u662f\u8f66\u578b\u96f6\u90e8\u4ef6\uff0c\u8bf7\u5148\u5220\u9664\u8f66\u578b',
  },
  EN: { //英文翻译
    DataName: "MDS name:",
    'id&ver': " MDS ID/Version:",
    table: "Form information",
    basicInfo: "Sender information",
    sendername: "Sender\:",
    senderTelephone: "Phone\:",
    companyName: "Enterprise name(ID)\:",
    address: "Address\:",
    sendDate: "Send date\:",
    rbasicInfo: "Sanctifier information",
    rreceiveName: "Sanctifier\:",
    rreceiveTelephone: "Phone\:",
    rcompanyName: "Enterprise name(ID)\:",
    raddress: "Address\:",
    rpizhunDate: "Sanctifier information",
    analyse: "Harmful substance analyze list",
    beizhu: "(PS\: \u221A\uFF1Ainclude and compliance\uFF1B\u2573\uFF1Anoncompliance\uFF1BN.A.\uFF1Anone\uFF1B\u3007\uFF1AHigher than the limit but exempt)",
    partcomponetName: "Subcomponent name",
    materialName: "Material name",
    materialClass: "Material catalogs",
    option: "Exempt options",
    isOpen:'Open',
    secretOption:"Security",
    isOpen:'',
    delete: 'Delete',
    success1: 'The operation has been successful except for the accepted or downloaded MDS\uFF01',
    copyType: 'Select copy type',
    forward: 'Forwarding',
    newVersion: 'New version',
    copy: 'Copy',
    continue: 'Continue',
    notice: 'This MDS has been removed. Do you want to continue?',
    cancel: 'Cancel',
    title: 'Copy MDS',
    pleasewait: 'Please wait a moment',
    imdsSelect: 'More than 10 MDSs are selected, it will affect the efficiency when uploading and downloading. We suggest you to choose less than 10 MDSs at a time!',
    lock: ' lock',
    unlock: 'unlock',
    lockmsg: 'MDS is locked',
    lockmsg: 'MDS will be locked.',
    checkVehcleMsg: 'This part is a model part, please delete the model first ',

  }
}
export default info //需要暴露出去
